import { Envelope, MapPin, Buildings } from "@phosphor-icons/react";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import LeadForm from "../components/LeadForm";
import { Reveal } from "../components/motion";
import { IMAGES } from "../data/images";

export default function Contact() {
  return (
    <Layout>
      <SEO title="Contact" description="Discuss your supply chain operations with Eazymuv. One accountable execution partner across factory, warehouse and logistics." />
      <PageHeader dark eyebrow="Contact" title={<>Let's discuss your operations</>} subtitle="Tell us where execution is breaking down. We'll show you how one accountable model closes the gap." image={IMAGES.reeferTruck} imageAlt="Refrigerated freight truck" />
      <section className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <div className="border border-ez-text divide-y divide-ez-text">
              {[
                { i: Buildings, t: "Eazymuv Technologies Pvt Ltd", d: "Supply chain execution company" },
                { i: Envelope, t: "General enquiries", d: "mohit@eazymuv.com" },
                { i: MapPin, t: "Operating regions", d: "India — expanding across sites and lanes" },
              ].map((c, i) => (
                <div key={i} className="p-6 flex gap-4">
                  <c.i size={26} weight="duotone" className="text-ez-text shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold">{c.t}</div>
                    <div className="text-sm text-ez-text/60 mt-1">{c.d}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 text-sm text-ez-text/50">
              Looking for EazyMS specifically? Visit that page for the
              matching enquiry form.
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}><LeadForm variant="general" /></Reveal>
        </div>
      </section>
    </Layout>
  );
}
